/* eslint-disable consistent-return */
// import hash from 'object-hash'
import { apiPaths, getApiPath, httpStatus, NONE_VALUE } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET (array of objects)
// export const GET_FLOW_TASKS_SUCCESS = 'GET_FLOW_TASKS_SUCCESS'
// export const GET_FLOW_TASKS_FAILURE = 'GET_FLOW_TASKS_FAILURE'

// -- UPDATE
export const UPDATE_FLOW_TASK_SUCCESS = 'UPDATE_FLOW_TASK_SUCCESS'
export const UPDATE_FLOW_TASK_FAILURE = 'UPDATE_FLOW_TASK_FAILURE'

// -- ASSIGN a FLOW TASK ID
export const ASSIGN_FLOW_TASK_SUCCESS = 'ASSIGN_FLOW_TASK_SUCCESS'
export const ASSIGN_FLOW_TASK_FAILURE = 'ASSIGN_FLOW_TASK_FAILURE'

// ____________________________________________________________

/**
 * Get the flow tasks form the API and broadcast two types of events:
 * - GET_FLOW_TASKS_SUCCESS: in case of success
 * - GET_FLOW_TASKS_FAILURE: in case of failure.
 *
 * @param {UUID} pid Project Id number
 * @param {UUID} sid Scenario Id number
 * @param {UUID} fid FlowGroup Id UUID
 * @param {boolean} noCache if true reset cache.
 * @returns {Promise<object>}
 */
// let _cacheItems = []
// const _getCacheKey = (pid, sid, fid) => {
//   return hash({ pid, sid, fid })
// }
// const _getCacheItem = (pid, sid, fid) => {
//   return _cacheItems[_getCacheKey(pid, sid, fid)]
// }
// const _pushCacheItem = (pid, sid, fid, item) => {
//   _cacheItems[_getCacheKey(pid, sid, fid)] = item
// }

// export const getFlowTasks = (pid, sid, fid, noCache) => async (dispatch) => {
//   // const key = hash({ pid, sid, fid })
//   // let result = null
//   let result = _getCacheItem(pid, sid, fid)

//   if (!result || noCache === true) {
//     const path = getApiPath(apiPaths.FLOW_TASK_LIST, { pid, sid, fid })
//     const api = new Api(path)
//     result = await api.get()
//     _pushCacheItem(pid, sid, fid, result)
//     Logger.trace(LoggerTypes.ACTION, '[ACTION] flowTasksActions.getFlowTasks(INIT)', {
//       path,
//       _cacheItems,
//       noCache
//     })
//   } else {
//     // result = _getFlowTasksCache[key]
//     Logger.trace(LoggerTypes.ACTION, '[ACTION] flowTasksActions.getFlowTasks(CACHE)', { _cacheItems, noCache })
//   }

//   if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
//     return dispatch({
//       type: GET_FLOW_TASKS_SUCCESS,
//       data: result.data.items || []
//     })
//   }
//   return dispatch({
//     type: GET_FLOW_TASKS_FAILURE,
//     data: result.data
//   })
// }

/**
 * Update the values of a flowTask broadcast two types of events:
 * - UPDATE_FLOW_TASK_SUCCESS: in case of success
 * - UPDATE_FLOW_TASK_FAILURE: in case of failure.
 *
 * @param {UUID} pid Project Id UUID
 * @param {UUID} sid Scenario Id UUID
 * @param {UUID} fid FlowGroup Id UUID
 * @param {object} flowTask Flow task to update (must contain `id` UUID attribute)
 * @returns {Promise<object>}
 */
export const updateFlowTask = (pid, sid, fid, flowTask) => async (dispatch) => {
  if (!flowTask) {
    return
  }

  const path = getApiPath(apiPaths.FLOW_TASK_UPDATE, { pid, sid, fid, tid: flowTask.id })
  const api = new Api(path)
  const result = await api.update(flowTask)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowTasksActions.updateFlowTask()', { path, result, flowTask })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_FLOW_TASK_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_FLOW_TASK_FAILURE,
    data: result.data
  })
}

/**
 * Assign a Flow Task ID to the current flowTask, broadcast two types of events:
 * - ASSIGN_FLOW_TASK_SUCCESS: in case of success
 * - ASSIGN_FLOW_TASK_FAILURE: in case of failure.
 *
 * @param {UUID} pid Project Id UUID
 * @param {UUID} sid Scenario Id UUID
 * @param {UUID} fid FlowGroup Id UUID
 * @param {UUID} tid Flow Task UUID
 * @param {UUID} task_id Flow Task to assign to.
 * @returns {Promise<object>}
 */
export const assignFlowTask = (pid, sid, fid, tid, task_id) => async (dispatch) => {
  const path = getApiPath(apiPaths.FLOW_TASK_ASSIGN, { pid, sid, fid, tid })
  const api = new Api(path)
  const json_data = !task_id || task_id === NONE_VALUE ? {} : { task_id: task_id }
  const result = await api.update(json_data)
  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowTasksActions.assignFlowTask()', { path, result, task_id })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: ASSIGN_FLOW_TASK_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: ASSIGN_FLOW_TASK_FAILURE,
    data: result.data
  })
}
